"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncData = void 0;
const flow_connect_1 = require("flow-connect");
const core_1 = require("flow-connect/core");
class SyncData extends core_1.Node {
    constructor() {
        super();
        this.eventIds = [];
        this.hold = {};
    }
    setupIO(options) {
        this.addTerminals([
            { type: core_1.TerminalType.IN, name: "Data 1", dataType: "any" },
            { type: core_1.TerminalType.IN, name: "Data 2", dataType: "any" },
            { type: core_1.TerminalType.OUT, name: "synced", dataType: "any" },
        ]);
        if ((0, flow_connect_1.exists)(options.noOfInputs)) {
            for (let i = 0; i < options.noOfInputs - 2; i++) {
                this.addTerminal({ type: core_1.TerminalType.IN, dataType: "any", name: "Data " + (this.inputs.length + 1) });
            }
        }
    }
    created(options) {
        const { width = 160, name = "Sync Data", style = {}, state = {} } = options;
        this.width = width;
        this.name = name;
        this.style = Object.assign({ rowHeight: 10 }, style);
        this.state = Object.assign(Object.assign({}, SyncData.DefaultState), state);
        this.setupUI();
        this.setupListeners();
    }
    process() {
        const hold = [];
        for (let term of this.inputs) {
            if (this.hold.hasOwnProperty(term.id)) {
                hold.push(this.hold[term.id]);
            }
            else
                return;
        }
        if (this.state.syncType === "full")
            this.state.hold = {};
        this.outputs[0].emit(hold);
        for (let term of this.inputs)
            if (term.connectors.length > 0 && typeof term.getData() === "undefined")
                return;
        this.setOutputs(0, this.getInputs());
    }
    setupUI() {
        this.syncTypeInput = this.createUI("core/radio-group", {
            values: ["partial", "full"],
            selected: this.state.syncType,
            propName: "syncType",
            height: 20,
        });
        this.addButton = this.createUI("core/button", { text: "Add", input: true, output: true, height: 20 });
        this.ui.append([this.syncTypeInput, this.addButton]);
    }
    setupListeners() {
        this.addButton.on("click", () => {
            const newTerminal = this.addTerminal({
                type: core_1.TerminalType.IN,
                dataType: "any",
                name: "Data " + (this.inputs.length + 1),
            });
            this.eventIds.push(newTerminal.on("data", (inst, data) => {
                this.hold[inst.id] = data;
                this.process();
            }));
        });
        for (let terminal of this.inputs) {
            this.eventIds.push(terminal.on("data", (inst, data) => {
                this.hold[inst.id] = data;
                this.process();
            }));
        }
    }
}
exports.SyncData = SyncData;
SyncData.DefaultState = { syncType: "partial" };
